
import { defineComponent } from 'vue';
import axios from 'axios';

import { INQUIRY_PARAM } from '@/types/inquiry';

import TPConfirmPop from './common/popup/TPConfirmPop.vue';

export default defineComponent({
	components: {
		TPConfirmPop,
	},
	props: {
		pToggleInquiryModal: Function as any,
	},
	data() {
		return {
			mScreenWidth: window.innerWidth,
			mYesMobile: false,
			mPopInfo: {
				title: '문의하기',
				closeFn: this.pToggleInquiryModal,
				size: { w: '1000px', h: 'auto' },
				btnList: [
					{
						btnType: 'noBorder',
						btnText: '문의하기',
						pointYn: true,
						onClickFn: this.postInquiry,
					},
					{
						btnType: 'noBorder',
						btnText: '닫기',
						pointYn: false,
						onClickFn: this.pToggleInquiryModal,
					},
				],
				isFull: true,
			},
			isChecked: false,
			inputInfos: {
				titleInput: {
					type: 'T',
					value: '',
					placeholder: '제목을 입력해주세요.',
				},
				userNumberInput: {
					type: 'T',
					value: '',
					placeholder: '연락처를 입력해주세요.',
				},
				userEmailInput: {
					type: 'T',
					value: '',
					placeholder: '이메일을 입력해주세요.',
				},
				userNameInput: {
					type: 'T',
					value: '',
					placeholder: '이름을 입력해주세요.',
				},
				bodyFullStrInput: {
					type: 'TA',
					value: `문의 내용: `,
					placeholder: '문의하시는 내용을 입력해주세요.',
					backgrounColor: '#fff',
					padding: '10px',
				},
			},
			textareaDefaultValue: `\n전화번호: \n\n이메일: \n\n문의 내용: \n\n`,
			showAlertPop: false,
			alertPopInfo: {
				alertText: ``,
				closeFn: this.toggleAlertPop,
			},
			showSuccessPop: false,
			successPopInfo: {
				alertText: `문의가 등록되었습니다.<br/>빠른 시일 내에 답변을 드리겠습니다.`,
				closeFn: this.toggleSuccessPop,
			},
			mFAQ: [
				{ id: '01', que: 'Q. 문의 후 답변은 언제 오나요?', ans: 'A. 영업일 기준 1~2일 내에 답변을 받아보실 수 있습니다.', showBtn: false, closeBtn: true },
				{ id: '02', que: 'Q. 구매 후 도입 순서가 어떻게 되나요?', ans: 'A.구매 후 계약을 체결하고, 이후 업무 시스템에 적용할 수 있도록 개발에 관한 기술을 지원합니다.', showBtn: true, closeBtn: false },
				{ id: '03', que: 'Q. 솔루션 도입 후 연동 및 적용까지의 시간은 얼마나 걸리나요?', ans: 'A. 연동 및 적용까지의 모든 과정은 보통 2~3일 내외로 소요됩니다.', showBtn: true, closeBtn: false },
			],
			mAnswerIndex: 0,
			mShowAnswer: false,
			mSelectedOptionIdx: 0,
			mSelectedOptionArr: [] as number[],
			mSelectedAskIdx: 0,
			mSelectedAskArr: [] as number[],
			mOptions: [
				{ val: 'viewer', name: '문서 뷰어', checkedYn: false },
				{ val: 'changer', name: '문서 변환', checkedYn: false },
				{ val: 'filter', name: '개인정보 필터', checkedYn: false },
				{ val: 'all', name: '모두', checkedYn: false }
			],
			mAskFor: [
				{ val: 'buying', name: '구매 문의', checkedYn: false },
				{ val: 'toUse', name: '사용 방법', checkedYn: false },
				{ val: 'error', name: '오류 문의', checkedYn: false },
			]
		};
	},
	methods: {
		toggleAlertPop() {
			this.showAlertPop = !this.showAlertPop;
		},
		toggleSuccessPop() {
			this.showSuccessPop = !this.showSuccessPop;
			if (!this.showSuccessPop) {
				this.pToggleInquiryModal();
			}
		},
		openAnswer(index: number) {
			this.mAnswerIndex = index
			this.mFAQ[this.mAnswerIndex].showBtn = !this.mFAQ[this.mAnswerIndex].showBtn
			console.log('mFAQs', this.mFAQ)
			// this.mFAQs[this.mAnswerIndex].closeBtn = true
			this.mShowAnswer = true
		},
		closeAnswer() {
			this.mFAQ[this.mAnswerIndex].showBtn = true
			this.mFAQ[this.mAnswerIndex].closeBtn = false
			this.mShowAnswer = false
		},
		async postInquiry() {
			if (this.mSelectedAskArr.length === 0) {
				this.alertPopInfo.alertText = `문의 유형을 선택하세요.`;
        this.toggleAlertPop();
			} else if (this.mSelectedOptionArr.length === 0 ) {
				this.alertPopInfo.alertText = `문의할 제품을 선택하세요.`;
        this.toggleAlertPop();
			} else if (!this.inputInfos.titleInput.value) {
        this.alertPopInfo.alertText = `제목을 입력하세요.`;
        this.toggleAlertPop();
      } else if (!this.inputInfos.userNameInput.value) {
        this.alertPopInfo.alertText = `문의자명을 입력해주세요.`;
        this.toggleAlertPop();
			} else if (!this.inputInfos.userNumberInput.value) {
				this.alertPopInfo.alertText = `연락처를 입력해주세요.`;
				this.toggleAlertPop();
			} else if (!this.inputInfos.userEmailInput.value) {
				this.alertPopInfo.alertText = `이메일을 입력해주세요.`;
				this.toggleAlertPop();
			} else if ( this.inputInfos.bodyFullStrInput.value === this.textareaDefaultValue) {
        this.alertPopInfo.alertText = `상세 문의 내용을 입력해주세요.`;
        this.toggleAlertPop();
      } else if (!this.isChecked) {
        this.alertPopInfo.alertText = `개인 정보 수집 및 이용에 동의해주세요.`;
        this.toggleAlertPop();
      } else {
        const param: INQUIRY_PARAM = {
          title: this.inputInfos.titleInput.value, // input data
          bodyFullStr: this.inputInfos.bodyFullStrInput.value, // input data
          bodyHtmlYn: true,
          jobkindId: 'BOAR',
          cabinetKey: 13362,
          onlyManagerYn: false,
          creUserName: this.inputInfos.userNameInput.value, // input data
          creUserKey: 0,
          showCreNameYn: true,
          devNotiYn: false,
          cabinetName: '팀플유틸 문의하기',
          creTeamKey: 435,
        };
        await axios
          .post('https://mo.d-alim.com/service/tp.saveContents', param, {
            headers: {
              'Content-type': 'application/json; text/html; charset=utf-8;',
              'Access-Control-Allow-Origin': '*',
              'Access-Control-Allow-Methods':
                'GET,POST,PATCH,PUT,DELETE,OPTIONS',
              'Access-Control-Allow-Headers':
                'Origin, Content-Type, X-Auth-Token',
              'Access-Control-Allow-Credentials': true,
            },
          })
          .then((res) => {
            if (res.data.result === true) {
              console.log('문의 완료', res.status);
              this.toggleSuccessPop();
            } else {
              console.log('문의 등록 실패');
              console.log(
                'status',
                res.status,
                '요청은 전달되었으나 등록에 실패하였습니다.'
              );
            }
          })
          .catch((err) => {
            console.log('문의 등록 실패', err);
            this.alertPopInfo.alertText = `문의 등록에 실패했습니다.\n다시 시도해주세요.`;
            this.toggleAlertPop();
          });
      }
    },
    handleChangeCheckbox() {
      this.isChecked = !this.isChecked;
		},
		getOptionIdx(index: number) {
			this.mSelectedOptionIdx = index
			const selectedOptionIndex = this.mSelectedOptionArr.indexOf(index);
			if (selectedOptionIndex === -1) {
        this.mSelectedOptionArr.push(index);
      } else {
        this.mSelectedOptionArr.splice(selectedOptionIndex, 1);
			}
			console.log('selectedIndex', selectedOptionIndex)
			console.log('mSelectedOptionArr', this.mSelectedOptionArr)
		},
		isSelected(index: number) {
      return this.mSelectedOptionArr.includes(index);
		},
		getAskIdx(index: number) {
			this.mSelectedAskIdx = index
			const selectedAskIndex = this.mSelectedAskArr.indexOf(index);
			if (selectedAskIndex === -1) {
        this.mSelectedAskArr.push(index);
      } else {
        this.mSelectedAskArr.splice(selectedAskIndex, 1);
			}
			console.log('selectedIndex', selectedAskIndex)
			console.log('mSelectedAskArr', this.mSelectedAskArr)
		},
		isAskSelected(index: number) {
      return this.mSelectedAskArr.includes(index);
    },
		handleResize() {
      const windowWidth = window.innerWidth;
      this.mYesMobile = windowWidth <= 750;
		}
	},
	mounted() {
		window.addEventListener('resize', this.handleResize);
		this.handleResize();
	},
});
